import React, { useState, useRef, useEffect } from 'react';

import './container.css';


/**
 * ---------------------------------------------------------------------
 * ScrollContainer
 * ---------------------------------------------------------------------
 * function component
 *
 * container which scrolls vertival
 * if scrollbar is visible it add an padding
 */
function ScrollContainer (props) {
        const contRef = useRef();
        const [scrollable, setScrollable] = useState(false);

        // hook to check on resize or content change the scroll bar
        useEffect(() => {
            if( contRef.current.scrollHeight  > contRef.current.clientHeight ) {
                setScrollable(true);
            } else {
                setScrollable(false);
            }

            function handleResize() {
                if( contRef.current.scrollHeight  > contRef.current.clientHeight ) {
                    setScrollable(true);
                } else {
                    setScrollable(false);
                }
            }

            window.addEventListener('resize', handleResize);

            return _ => {
                window.removeEventListener('resize', handleResize);
            }

        },[setScrollable,props.forceScrollUpdate]);

        // render
        let cssClass = "scroll-container";

        if( scrollable )
            cssClass = cssClass + " scrollable";

        if( props.className )
            cssClass = cssClass + " " + props.className;

        return (<div ref={contRef} className={cssClass}>
                    { props.children }
                </div>);
}

/*
* ---------------------------------------------------------------------
* Export
* ---------------------------------------------------------------------
*/
export default ScrollContainer;
